:root {
  --color-ink: #1b1a19;
  --color-ink-soft: #2c2a28;
  --color-charcoal: #3b3531;
  --color-sand: #d2c3b2;
  --color-bone: #f5f2ee;
  --color-ember: #f39a2e;
  --color-ember-dark: #c8771d;
  --color-olive: #6d665a;
  --color-steel: #5b6a76;

  --font-display: "Roboto", "Montserrat", sans-serif;
  --font-body: "Roboto", "Montserrat", sans-serif;

  --space-1: 4px;
  --space-2: 8px;
  --space-3: 12px;
  --space-4: 16px;
  --space-5: 24px;
  --space-6: 32px;
  --space-7: 48px;
  --space-8: 64px;

  --radius-sm: 6px;
  --radius-md: 12px;
  --radius-lg: 18px;

  --shadow-soft: 0 12px 30px rgba(0, 0, 0, 0.18);
  --shadow-card: 0 10px 24px rgba(0, 0, 0, 0.22);

  /* Named breakpoints — every @media (max-width: ...) in the codebase
     should map to one of these. CSS custom properties can't be used
     inside @media queries, but keeping them here makes the contract
     visible for grep + future tooling.
       --bp-sm  540px   phones portrait
       --bp-md  768px   phones landscape, small tablets portrait
       --bp-lg  1024px  tablets landscape, small laptops
       --bp-xl  1280px  desktop                                    */
  --bp-sm: 540px;
  --bp-md: 768px;
  --bp-lg: 1024px;
  --bp-xl: 1280px;

  /* Fluid type scale — clamp(min, viewport-fluid, max). Use these
     instead of fixed font sizes so headings scale across phone →
     desktop without a heap of @media overrides. */
  --fs-xs:   clamp(0.72rem, 0.7vw + 0.6rem,  0.78rem);
  --fs-sm:   clamp(0.82rem, 0.6vw + 0.7rem,  0.92rem);
  --fs-base: clamp(0.92rem, 0.5vw + 0.8rem,  1.05rem);
  --fs-md:   clamp(1.0rem,  0.6vw + 0.85rem, 1.15rem);
  --fs-lg:   clamp(1.15rem, 1vw + 0.9rem,    1.35rem);
  --fs-xl:   clamp(1.4rem,  1.6vw + 1rem,    1.8rem);
  --fs-2xl:  clamp(1.7rem,  2.4vw + 1.1rem,  2.4rem);
  --fs-3xl:  clamp(2rem,    3.4vw + 1.2rem,  3.2rem);

  /* Fluid section padding — replaces hard-coded var(--space-5) /
     var(--space-6) on .page wrappers. Compresses on phones, expands
     on wide desktop, no media queries needed. */
  --page-pad-x: clamp(16px, 3.5vw, 32px);
  --page-pad-y: clamp(20px, 3vw, 40px);
}
